import { render, staticRenderFns } from "./AdminAddFile.vue?vue&type=template&id=6a9fae10&"
import script from "./AdminAddFile.vue?vue&type=script&lang=js&"
export * from "./AdminAddFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports